/**
 * Qual vaga da tela a promoção vai pedir: a principal, a do rodapé, ou nenhuma.
 *
 * Existe por causa do `banner_timer`. O popup espera N segundos antes de decidir
 * (hoje, 10), e nesses N segundos a Saída do Assine já pediu e levou a tela. Para
 * a promoção ter a precedência que o negócio pediu, ela precisa segurar a vez
 * ANTES do timer — e para isso é preciso prever, no instante zero, se ela de fato
 * vai pedir a tela quando o timer estourar.
 *
 * Função pura: recebe o estado, devolve a vaga. Não lê cookie nem toca no DOM,
 * para poder ser exercitada no runner de teste.
 */

export type VagaPromocional = "principal" | "rodape" | null

export interface EstadoPromocao {
  /** A promoção tem peça principal? (imagem/vídeo do popup, ou o modal de e-mail.) */
  temPrincipal: boolean
  /** A promoção tem peça de rodapé cadastrada. */
  temRodape: boolean
  /** Lista de contagens de acesso em que a promoção aparece, ex.: "1,2,3,4". */
  display: string
  /** Contagem de acessos deste visitante (cookie countAccessPromotion). */
  contagem: string
  /** Estágio do visitante nesta promoção (cookie bellaPromoShow): "1" → ainda não viu a principal; "0" → fechou a principal, vez do rodapé; "2" → fechou o rodapé também. */
  estagio: string | undefined
  /** O rodapé já foi desligado para este visitante (cookie showFooterPromoBanner). */
  rodapeDesligado: boolean
}

/**
 * ATENÇÃO — esta função espelha as condições do `showModal()` dos dois
 * componentes de popup (`ModalPromotionPopup.vue` e `ModalPromotionPopupEmail.vue`).
 * Ela decide apenas se a promoção SEGURA a vez; quem decide se a promoção ABRE
 * continua sendo o `showModal()`, intocado.
 *
 * A separação é deliberada: mexer no `showModal()` arriscaria a exibição da
 * campanha em si, e errar aqui custa pouco e se conserta sozinho — a reserva tem
 * prazo e vence. Se um dia as condições do `showModal()` mudarem, o pior que
 * acontece é a Saída do Assine ficar bloqueada por alguns segundos a mais, ou a
 * promoção perder a precedência numa visita. Nunca dois modais na tela.
 */
export function vagaQueSeraPedida(estado: EstadoPromocao): VagaPromocional {
  const contagemBate =
    estado.display !== "" &&
    estado.display
      .toString()
      .split(",")
      .includes(String(estado.contagem))

  if (!contagemBate) {
    return null
  }

  if (estado.temPrincipal && estado.estagio === "1") {
    return "principal"
  }

  const vezDoRodape =
    estado.estagio === "0" || (estado.estagio === "1" && !estado.temPrincipal)

  if (!estado.rodapeDesligado && vezDoRodape && estado.temRodape) {
    return "rodape"
  }

  return null
}
